import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "filter-bar-row"
};
const _hoisted_2 = {
  key: 0,
  class: "filter-bar-actions"
};
const _hoisted_3 = {
  key: 0,
  class: "mt-4 flex flex-wrap items-center justify-end gap-2"
};
const _hoisted_4 = {
  key: 0,
  class: "mr-auto flex flex-wrap items-center gap-2"
};
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
  key: 1,
  class: "mt-4"
};
import { computed } from 'vue';
export default {
  __name: 'PageFilterBar',
  props: {
    shellClass: {
      type: String,
      default: 'filter-bar-shell'
    },
    bodyClass: {
      type: String,
      default: 'filter-bar-body'
    },
    contentClass: {
      type: String,
      default: 'filter-bar-content is-page'
    },
    showRefresh: {
      type: Boolean,
      default: false
    },
    refreshLoading: {
      type: Boolean,
      default: false
    },
    refreshDisabled: {
      type: Boolean,
      default: false
    },
    refreshText: {
      type: String,
      default: '刷新'
    }
  },
  emits: ['refresh'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const shellClass = computed(() => props.shellClass);
    const bodyClass = computed(() => props.bodyClass);
    const contentClass = computed(() => props.contentClass);
    const handleRefresh = () => {
      if (props.refreshDisabled || props.refreshLoading) return;
      emit('refresh');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(shellClass.value)
      }, [_createElementVNode("div", {
        class: _normalizeClass(bodyClass.value)
      }, [_createElementVNode("div", {
        class: _normalizeClass(contentClass.value)
      }, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")]), _ctx.$slots.actions ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "actions")])) : _createCommentVNode("", true)], 2), __props.showRefresh || _ctx.$slots.searchActions || _ctx.$slots.searchActionsLeading ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_ctx.$slots.searchActionsLeading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_renderSlot(_ctx.$slots, "searchActionsLeading")])) : _createCommentVNode("", true), __props.showRefresh ? (_openBlock(), _createElementBlock("button", {
        key: 1,
        type: "button",
        class: "btn-secondary inline-flex items-center gap-2",
        disabled: __props.refreshDisabled || __props.refreshLoading,
        onClick: handleRefresh
      }, [(_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["h-4 w-4", {
          'animate-spin': __props.refreshLoading
        }]),
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [...(_cache[0] || (_cache[0] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
      }, null, -1)]))], 2)), _createElementVNode("span", null, _toDisplayString(__props.refreshText), 1)], 8, _hoisted_5)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "searchActions")])) : _createCommentVNode("", true), _ctx.$slots.extra ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_renderSlot(_ctx.$slots, "extra")])) : _createCommentVNode("", true)], 2)], 2);
    };
  }
};